import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconHeaderLang = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 22,
	height: 22,
	viewBox: "0 0 22 22",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M11 21.25C16.6609 21.25 21.25 16.6609 21.25 11C21.25 5.33908 16.6609 0.75 11 0.75C5.33908 0.75 0.75 5.33908 0.75 11C0.75 16.6609 5.33908 21.25 11 21.25Z",
			stroke: "#212629",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 21.25C13.3472 21.25 15.25 16.6609 15.25 11C15.25 5.33908 13.3472 0.75 11 0.75C8.65279 0.75 6.75 5.33908 6.75 11C6.75 16.6609 8.65279 21.25 11 21.25Z",
			stroke: "#212629",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1 11H21",
			stroke: "#212629",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 5C5.46211 6.31313 8.20961 7 11 7C13.7904 7 16.5379 6.31313 19 5",
			stroke: "#212629",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M3 17C5.46211 15.6869 8.20961 15 11 15C13.7904 15 16.5379 15.6869 19 17",
			stroke: "#212629",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		})
	]
});
export default SvgIconHeaderLang;
